/**
 * iCarsoft 产品目录页(依据 2026 产品列表页设计稿)
 * 数据:Liquid 输出的实时产品 JSON(价格/图片/评分随市场与后台实时变动,产品主图用店铺原图)
 * 元数据:handle → 设计稿分类/场景/特性标签映射;未映射产品自动推断归类
 */
(() => {
  const root = document.querySelector('.icat');
  if (!root) return;

  /* ===== 设计稿常量 ===== */
  const FEAT = { bidi: 'Bi-directional', canfd: 'CAN FD · DoIP', coding: 'ECU coding', allsys: 'All systems', wifi: 'Touchscreen · WiFi', wireless: 'Wireless VCI', lifetime: 'Lifetime updates' };
  const VEH = { car: 'Car', moto: 'Motorcycle', truck: 'Heavy duty', marine: 'Marine', universal: 'Multi-brand' };
  const CATS = [
    { key: 'flagship', eyebrow: 'Tier 01 — Professional', title: 'Flagship Diagnostic Tablets', desc: 'OE-level, all-system tablets with ECU coding, CAN FD & DoIP — built for busy workshops and serious pros.' },
    { key: 'multi', eyebrow: 'Tier 02 — Multi-brand', title: 'Multi-Brand Scanners', desc: 'One tool, dozens of makes. Bi-directional testing and full-system coverage for enthusiasts and side-hustle mechanics.' },
    { key: 'single', eyebrow: 'Tier 03 — By your car', title: 'Single-Brand Specialists', desc: 'Deep, dealer-level coverage for one marque. Pick your brand, then the version that matches how far you go.' },
    { key: 'moto', eyebrow: 'Vertical — Two wheels', title: 'Motorcycle Diagnostics', desc: 'Multi-system scanning for most motorcycle brands, plus dedicated tools for Harley, BMW, and more.' },
    { key: 'hd', eyebrow: 'Vertical — Commercial', title: 'Heavy Duty & Trucks', desc: 'For diesel trucks, buses, and commercial fleets — from a budget code reader to a full workshop package.' },
    { key: 'marine', eyebrow: 'Vertical — On the water', title: 'Marine Diagnostics', desc: 'Engine diagnostics built for the marine environment.' },
    { key: 'tpms', eyebrow: 'Vertical — Tyres', title: 'TPMS Tools', desc: 'Program, relearn, and diagnose tyre-pressure sensors — with OBD-II diagnostics built in.' },
    { key: 'acc', eyebrow: 'Extras', title: 'Accessories & Add-ons', desc: 'Adapters, cables, VCIs and add-on modules for your iCarsoft tool.' }
  ];
  const SCN = [
    { id: 'sc-one', t: 'I have one car', c: 'One specific brand', cat: ['single'], ico: '<path d="M5 13l1.5-4.5A2 2 0 018.4 7h7.2a2 2 0 011.9 1.5L19 13M5 13h14v4H5zM7 17v2M17 17v2"/><circle cx="8" cy="15" r=".6"/><circle cx="16" cy="15" r=".6"/>' },
    { id: 'sc-multi', t: 'Multi-brand', c: 'Many makes, one tool', cat: ['multi', 'flagship'], ico: '<rect x="4" y="5" width="16" height="11" rx="1.5"/><path d="M8 20h8M12 16v4M8 9h8M8 12h5"/>' },
    { id: 'sc-pro', t: 'Pro workshop', c: 'ECU coding · OE-level', cat: ['flagship'], ico: '<path d="M14 6l-2 2 4 4 2-2a3 3 0 00-4-4zM12 8l-7 7v3h3l7-7"/>' },
    { id: 'sc-moto', t: 'Motorcycle', c: 'Bikes & scooters', cat: ['moto'], ico: '<circle cx="6" cy="16" r="3"/><circle cx="18" cy="16" r="3"/><path d="M6 16l4-6h5l2 6M10 10l-1-2H7"/>' },
    { id: 'sc-hd', t: 'Heavy duty', c: 'Trucks & diesel', cat: ['hd'], ico: '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7zM3 15v2M7 17a1.5 1.5 0 103 0M17 17a1.5 1.5 0 103 0"/>' },
    { id: 'sc-tpms', t: 'TPMS', c: 'Tyre sensors', cat: ['tpms'], ico: '<circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2.5"/><path d="M12 5v2M12 17v2M5 12h2M17 12h2"/>' },
    { id: 'sc-marine', t: 'Marine', c: 'Boats & watercraft', cat: ['marine'], ico: '<path d="M4 17c1.3 1.1 2.7 1.1 4 0s2.7-1.1 4 0 2.7 1.1 4 0 2.7-1.1 4 0M6 14l1.2-5H14l3 5M10 9V5h2.5v4"/>' }
  ];
  const BRAND_ORDER = ['Porsche', 'Mercedes-Benz', 'BMW / Mini', 'Land Rover / Jaguar', 'VW / Audi / Škoda', 'Volvo / Saab', 'Opel / Vauxhall', 'Ford / GM / American', 'Japanese / Korean', 'French / Italian'];
  const BRAND_COVERS = {
    'Porsche': 'Porsche · Cayenne',
    'Mercedes-Benz': 'Mercedes · Sprinter · Smart · Maybach',
    'BMW / Mini': 'BMW · Mini · Rolls-Royce',
    'Land Rover / Jaguar': 'Land Rover · Jaguar',
    'VW / Audi / Škoda': 'VW · Audi · Škoda · Seat · Bentley',
    'Volvo / Saab': 'Volvo · Saab',
    'Opel / Vauxhall': 'Opel · Vauxhall',
    'Ford / GM / American': 'Ford · GM · Chrysler · Jeep · Dodge · Holden',
    'Japanese / Korean': 'Toyota · Lexus · Nissan · Honda · Hyundai · Kia · Subaru · Suzuki',
    'French / Italian': 'Peugeot · Citroën · Renault · Fiat · Alfa Romeo'
  };

  /* ===== handle → 设计稿元数据(2026-07 逐产品调研) ===== */
  const M = (code, cat, veh, fn, vehTag, tags, feat, brand, flag) => ({ code, cat, veh, fn, vehTag, tags, feat, brand, flag });
  const META = {
    'icarsoft-cr-unicorn-for-passenger-cars': M('CR-UNS', 'flagship', ['universal', 'truck'], 'OE-level flagship covering cars plus commercial trucks in one tablet.', 'Cars + Trucks', ['bidi', 'canfd', 'coding', 'allsys', 'lifetime'], 9, null, 'top'),
    'cr-unicorn': M('CR-UNI', 'flagship', ['universal'], 'OE-level diagnostics for cars, coaches and buses with topology mapping.', 'Cars · Coaches', ['bidi', 'canfd', 'coding', 'allsys', 'lifetime'], 8),
    'cr-ultra-p': M('CR-ULP', 'flagship', ['universal'], 'ECU coding, CAN FD, DoIP and topology map across 200+ models.', '200+ models', ['bidi', 'canfd', 'coding', 'allsys', 'lifetime'], 10, null, 'deal'),
    'cr-ultra': M('CR-ULT', 'flagship', ['universal'], 'Advanced pro scanner with a wireless Bluetooth VCI.', 'Multi-brand', ['bidi', 'canfd', 'coding', 'allsys', 'wireless', 'lifetime'], 7),
    'cr-eagle-p': M('CR-EGP', 'flagship', ['universal'], '2026 flagship tablet with full CAN FD & DoIP protocol support.', 'Multi-brand', ['bidi', 'canfd', 'coding', 'allsys', 'wifi', 'lifetime'], 9, null, 'new'),
    'icarsoft-cr-eagle': M('CR-EGL', 'flagship', ['universal'], 'Professional bi-directional tablet for full-system work.', 'Multi-brand', ['bidi', 'allsys', 'wifi', 'lifetime'], 6),
    'cr-legend': M('CR-LGD', 'flagship', ['universal'], 'Tablet with CAN FD & DoIP support for newer vehicles.', 'Multi-brand', ['bidi', 'canfd', 'allsys', 'wifi', 'lifetime'], 6),
    'icarsoft-cr-max-p': M('CR-MXP', 'multi', ['universal'], 'Bi-directional coverage for 58 brands with lifetime updates.', '58 brands', ['bidi', 'allsys', 'lifetime'], 8, null, 'deal'),
    'icarsoft-cr-max-bt-enhanced-wireless-bidirectional-diagnostic-tool': M('CR-MBE', 'multi', ['universal'], 'Wireless bi-directional scanning with an enhanced VCI.', 'Multi-brand', ['bidi', 'allsys', 'wireless', 'lifetime'], 7),
    'cr-max-bt': M('CR-MBT', 'multi', ['universal'], 'Bluetooth wireless scanner covering all onboard systems.', 'Multi-brand', ['bidi', 'allsys', 'wireless', 'lifetime'], 6),
    'cr-max': M('CR-MAX', 'multi', ['universal'], 'All-system, best-reviewed multi-brand workhorse.', 'Multi-brand', ['bidi', 'allsys', 'lifetime'], 6, null, 'top'),
    'icarsoft-cr-pro-s': M('CR-PRS', 'multi', ['universal'], 'Bi-directional testing across all systems and makes.', 'Multi-brand', ['bidi', 'allsys', 'lifetime'], 6, null, 'deal'),
    'icarsoft-cr-pro': M('CR-PR+', 'multi', ['universal'], 'Fan-favourite all-system scanner for everyday DIY.', 'Multi-brand', ['allsys', 'lifetime'], 5),
    'icarsoft-por-v4-0': M('POR-V4', 'single', ['car'], 'Newest Porsche series — touchscreen and WiFi.', 'Porsche', ['allsys', 'wifi', 'lifetime'], 6, 'Porsche', 'new'),
    'por-v3-0': M('POR-V3', 'single', ['car'], 'All-systems Porsche diagnostics with service resets.', 'Porsche', ['allsys', 'lifetime'], 5, 'Porsche'),
    'por-v2-0': M('POR-V2', 'single', ['car'], 'All-systems Porsche coverage for common maintenance.', 'Porsche', ['allsys'], 4, 'Porsche'),
    'p700-v2-0': M('P700-V2', 'single', ['car'], 'Focused Porsche diagnostics and service functions.', 'Porsche', ['allsys'], 4, 'Porsche'),
    'por-v1-0': M('POR-V1', 'single', ['car'], 'Entry Porsche / Cayenne scan tool for core systems.', 'Porsche', [], 3, 'Porsche'),
    'por-ii-1': M('POR-II', 'single', ['car'], 'Porsche scan tool — price-drop deal.', 'Porsche', ['allsys'], 3, 'Porsche', 'deal'),
    'por-ii': M('POR-II', 'single', ['car'], 'Porsche multi-system scan tool.', 'Porsche', ['allsys'], 3, 'Porsche'),
    'icarsoft-mb-v4-0': M('MB-V4', 'single', ['car'], 'Mercedes / Sprinter / Smart / Maybach — top-reviewed.', 'Mercedes-Benz', ['allsys', 'wifi', 'lifetime'], 6, 'Mercedes-Benz', 'top'),
    'mb-v3-0-enhanced-edition': M('MB-V3E', 'single', ['car'], 'MB V3.0 bundled with a 38-pin adapter for older Benz.', 'Mercedes-Benz', ['allsys', 'lifetime'], 5, 'Mercedes-Benz'),
    'mb-v3-0': M('MB-V3', 'single', ['car'], 'All-systems Mercedes / Sprinter / Smart diagnostics.', 'Mercedes-Benz', ['allsys', 'lifetime'], 5, 'Mercedes-Benz'),
    'mb-ii': M('MB-II', 'single', ['car'], 'Mercedes / Sprinter / Smart multi-system coverage.', 'Mercedes-Benz', ['allsys'], 4, 'Mercedes-Benz'),
    'mb-v2-0': M('MB-V2', 'single', ['car'], 'Mercedes / Sprinter / Smart service diagnostics.', 'Mercedes-Benz', ['allsys'], 4, 'Mercedes-Benz'),
    'mb-v1-0': M('MB-V1', 'single', ['car'], 'Entry Mercedes / Sprinter / Smart scan tool.', 'Mercedes-Benz', [], 3, 'Mercedes-Benz'),
    'i980': M('i980', 'single', ['car'], 'Entry Mercedes diagnostics for core systems.', 'Mercedes-Benz', [], 3, 'Mercedes-Benz'),
    'icarsoft-bmm-v4-0': M('BMM-V4', 'single', ['car'], 'BMW / Mini / Rolls-Royce — newest series, touchscreen.', 'BMW · Mini', ['allsys', 'wifi', 'lifetime'], 6, 'BMW / Mini', 'new'),
    'bmw-v3-0': M('BMM-V3', 'single', ['car'], 'All-systems BMW / Mini / Rolls-Royce diagnostics.', 'BMW · Mini', ['allsys', 'lifetime'], 5, 'BMW / Mini'),
    'bmm-v2-0': M('BMM-V2', 'single', ['car'], 'BMW / Mini multi-system coverage and resets.', 'BMW · Mini', ['allsys'], 4, 'BMW / Mini'),
    'bmm-v1-0': M('BMM-V1', 'single', ['car'], 'Entry BMW / Mini live-data scan tool.', 'BMW · Mini', [], 3, 'BMW / Mini'),
    'icarsoft-lr-v4-0': M('LR-V4', 'single', ['car'], 'Land Rover / Jaguar — newest series, all systems.', 'Land Rover · Jaguar', ['allsys', 'wifi', 'lifetime'], 6, 'Land Rover / Jaguar', 'new'),
    'lr-v3-0': M('LR-V3', 'single', ['car'], 'All-systems Land Rover / Jaguar diagnostics.', 'Land Rover · Jaguar', ['allsys', 'lifetime'], 5, 'Land Rover / Jaguar'),
    'lr-v2-0': M('LR-V2', 'single', ['car'], 'Land Rover / Jaguar with ABS & service functions.', 'Land Rover · Jaguar', ['allsys'], 4, 'Land Rover / Jaguar'),
    'lr-v1-0': M('LR-V1', 'single', ['car'], 'Entry Land Rover / Jaguar with SAS reset.', 'Land Rover · Jaguar', [], 3, 'Land Rover / Jaguar'),
    'icarsoft-de-v4-0': M('DE-V4', 'single', ['car'], 'All German makes — touchscreen and WiFi.', 'German makes', ['allsys', 'wifi', 'lifetime'], 6, 'VW / Audi / Škoda', 'new'),
    'icarsoft-vaws-v4-0': M('VAWS-V4', 'single', ['car'], 'VW / Audi / Škoda / Seat / Bentley — newest series.', 'VW · Audi · Škoda', ['allsys', 'wifi', 'lifetime'], 6, 'VW / Audi / Škoda'),
    'vaws-v3-0': M('VAWS-V3', 'single', ['car'], 'All-systems VW / Audi / Škoda diagnostics.', 'VW · Audi · Škoda', ['allsys', 'lifetime'], 5, 'VW / Audi / Škoda'),
    'vaws-v2-0': M('VAWS-V2', 'single', ['car'], 'VW / Audi / Škoda / Seat multi-system coverage.', 'VW · Audi · Škoda', ['allsys'], 4, 'VW / Audi / Škoda'),
    'vaws-v1-0': M('VAWS-V1', 'single', ['car'], 'Entry VW / Audi / Škoda scan tool.', 'VW · Audi · Škoda', [], 3, 'VW / Audi / Škoda'),
    'icarsoft-vol-v4-0': M('VOL-V4', 'single', ['car'], 'Volvo / Saab — newest series, all systems.', 'Volvo · Saab', ['allsys', 'wifi', 'lifetime'], 6, 'Volvo / Saab', 'new'),
    'vol-v3-0': M('VOL-V3', 'single', ['car'], 'All-systems Volvo / Saab diagnostics.', 'Volvo · Saab', ['allsys', 'lifetime'], 5, 'Volvo / Saab'),
    'vol-v2-0': M('VOL-V2', 'single', ['car'], 'Volvo / Saab multi-system coverage.', 'Volvo · Saab', ['allsys'], 4, 'Volvo / Saab'),
    'i906': M('i906', 'single', ['car'], 'New-arrival entry diagnostics for Volvo / Saab.', 'Volvo · Saab', [], 3, 'Volvo / Saab', 'new'),
    'vol-v1-0': M('VOL-V1', 'single', ['car'], 'Entry Volvo / Saab scan tool.', 'Volvo · Saab', [], 3, 'Volvo / Saab'),
    'icarsoft-op-v4-0': M('OP-V4', 'single', ['car'], 'Opel / Vauxhall — newest series, all systems.', 'Opel · Vauxhall', ['allsys', 'wifi', 'lifetime'], 6, 'Opel / Vauxhall', 'new'),
    'op-v3-0': M('OP-V3', 'single', ['car'], 'Opel / Vauxhall with Auto-VIN and quick test.', 'Opel · Vauxhall', ['allsys', 'lifetime'], 5, 'Opel / Vauxhall'),
    'op-v2-0': M('OP-V2', 'single', ['car'], 'Opel / Vauxhall multi-system coverage.', 'Opel · Vauxhall', ['allsys'], 4, 'Opel / Vauxhall'),
    'op-v1-0': M('OP-V1', 'single', ['car'], 'Entry Opel / Vauxhall scan tool.', 'Opel · Vauxhall', [], 3, 'Opel / Vauxhall'),
    'icarsoft-us-v4-0': M('US-V4', 'single', ['car'], 'Ford / GM / Chrysler / Jeep — newest US series.', 'US makes', ['allsys', 'wifi', 'lifetime'], 6, 'Ford / GM / American', 'new'),
    'us-v3-0': M('US-V3', 'single', ['car'], 'All-systems Ford / GM / Chrysler / Jeep diagnostics.', 'US makes', ['allsys', 'lifetime'], 5, 'Ford / GM / American'),
    'us-v2-0': M('US-V2', 'single', ['car'], 'Ford / GM / Chrysler / Jeep / Dodge coverage.', 'US makes', ['allsys'], 4, 'Ford / GM / American'),
    'i900': M('i900', 'single', ['car'], 'Entry GM diagnostics for core systems.', 'GM', [], 3, 'Ford / GM / American'),
    'fd-v1-0': M('FD-V1', 'single', ['car'], 'Entry Ford / Holden scan tool.', 'Ford · Holden', [], 3, 'Ford / GM / American'),
    'icarsoft-jp-v4-0': M('JP-V4', 'single', ['car'], 'Japanese & Korean makes — newest series, all systems.', 'JP · KR makes', ['allsys', 'wifi', 'lifetime'], 6, 'Japanese / Korean', 'new'),
    'jp-v3-0': M('JP-V3', 'single', ['car'], 'Nissan / Toyota / Honda / Hyundai / Kia and more.', 'JP · KR makes', ['allsys', 'lifetime'], 5, 'Japanese / Korean'),
    'jp-v2-0': M('JP-V2', 'single', ['car'], 'Toyota / Lexus / Nissan / Honda / Subaru / Kia.', 'JP · KR makes', ['allsys'], 4, 'Japanese / Korean'),
    'tyt-v1-0': M('TYT-V1', 'single', ['car'], 'Entry Toyota / Lexus / Scion / Isuzu scan tool.', 'Toyota · Lexus', [], 3, 'Japanese / Korean'),
    'icarsoft-fr-v4-0': M('FR-V4', 'single', ['car'], 'French & Italian makes — newest series, all systems.', 'FR · IT makes', ['allsys', 'wifi', 'lifetime'], 6, 'French / Italian', 'new'),
    'fr-v3-0': M('FR-V3', 'single', ['car'], 'Citroën / Peugeot / Renault / Fiat / Alfa coverage.', 'FR · IT makes', ['allsys', 'lifetime'], 5, 'French / Italian'),
    'fr-v2-0': M('FR-V2', 'single', ['car'], 'Citroën / Peugeot / Renault / Fiat / Alfa systems.', 'FR · IT makes', ['allsys'], 4, 'French / Italian'),
    'cp-v1-0': M('CP-V1', 'single', ['car'], 'Entry Peugeot / Citroën with oil reset.', 'Peugeot · Citroën', [], 3, 'French / Italian'),
    'professional-multi-systems-motorcycle-diagnostic-tool-mt-pro': M('MT-PRO', 'moto', ['moto'], 'Pro multi-system tool covering most motorcycle brands.', 'Most bikes', ['bidi', 'allsys', 'wifi', 'lifetime'], 6, null, 'top'),
    'mt-pro-mini': M('MT-MINI', 'moto', ['moto'], 'Compact multi-system scanner for most motorcycles.', 'Most bikes', ['allsys', 'wifi', 'lifetime'], 5),
    'mt-v6-plus': M('MT-V6P', 'moto', ['moto'], 'Essential-systems coverage across most motorcycles.', 'Most bikes', ['allsys', 'lifetime'], 4),
    'icarsoft-mt-v6-for-harley-davidson': M('MTV6-HD', 'moto', ['moto'], 'Dedicated Harley-Davidson motorcycle diagnostics.', 'Harley-Davidson', ['allsys'], 4),
    'mtv6-bmw': M('MTV6-BMW', 'moto', ['moto'], 'Dedicated BMW Motorrad diagnostics.', 'BMW Motorrad', ['allsys'], 4),
    'icarsoft-motorcycle-diagnostic-tool-mt-v6-for-suzuki': M('MTV6-SUZ', 'moto', ['moto'], 'Dedicated Suzuki motorcycle diagnostics.', 'Suzuki', ['allsys'], 4),
    'icarsoft-hd-v4-0-multi-system-heavy-duty-vehicles-diagnostic-tool': M('HD-V4', 'hd', ['truck'], 'Multi-system heavy-duty diagnostics on the newest platform.', 'Trucks · Diesel', ['allsys', 'wifi', 'lifetime'], 6, null, 'new'),
    'hd-v3-0': M('HD-V3', 'hd', ['truck'], 'Budget heavy-duty code reader for trucks.', 'Trucks · Diesel', [], 3),
    'hd2000-heavy-duty-truck-package': M('HD2000', 'hd', ['truck'], 'Complete heavy-duty workshop bundle.', 'Workshop kit', ['allsys'], 5),
    'marinescan-x9': M('X9', 'marine', ['marine'], 'Marine engine diagnostics — new arrival.', 'Marine engines', ['allsys'], 5, null, 'new'),
    'tpms-v800': M('TPMS-V800', 'tpms', ['car'], 'TPMS programming, relearn and OBD-II diagnostics.', 'TPMS + OBD-II', ['allsys'], 4),
    't-wand-9000': M('TW-9000', 'tpms', ['car'], 'TPMS activation wand, pairs with CR Ultra.', 'TPMS activation', [], 2)
  };

  /* ===== 实时产品数据 ===== */
  let LIVE = [];
  try { LIVE = JSON.parse(root.querySelector('[data-icat-products]').textContent); } catch (e) { LIVE = []; }

  const ACC_RE = /adapter|cable|\bvci\b|videoscope|oscilloscope|scop box|battery test|subscription|additional payment|20-pin|38-pin|14-pin|12\+8|obd2 adapter/i;
  const shortTitle = (t) => {
    let s = t.replace(/^iCarsoft\s+/i, '').replace(/^\[[^\]]*\]\s*/, '');
    s = s.replace(/\s+Motorcycle Diagnostic Tool(?=\s+for\s)/i, '');
    if (/^MT V6 for /i.test(s)) return s;
    const cut = [' — ', ' – ', ' - ', ' (', ' OE-Level', ' Advanced', ' Professional', ' 2026', ' Wireless', ' Bidirectional', ' Bi-Directional', ' NEW Version', ' WIFI', ' Bluetooth', ' TPMS Programming', ' TPMS Activation', ' Multi-System', ' Heavy Duty', ' OBDII', ' Motorcycle Diagnostic', ' Car Diagnostic', ' Automotive Diagnostic', ' Diagnostic', ' Videoscope', ' Battery Test'];
    let c = s.length;
    cut.forEach((m) => { const i = s.indexOf(m); if (i > 0 && i < c) c = i; });
    s = s.slice(0, c).trim().replace(/\s+for\s+.+$/i, '').replace(/\s+for$/i, '');
    return s || t;
  };

  const PRODUCTS = LIVE.map((p) => {
    const meta = META[p.handle] || (
      /MT V6/i.test(p.title) ? M(shortTitle(p.title).toUpperCase().slice(0, 10), 'moto', ['moto'], p.title.replace(/^iCarsoft\s+/i, ''), shortTitle(p.title).replace(/^MT V6 for /i, ''), ['allsys'], 4)
      : ACC_RE.test(p.title) ? M(shortTitle(p.title).toUpperCase().slice(0, 10), 'acc', ['universal'], p.title.replace(/^iCarsoft\s+/i, ''), 'Accessory', [], 2)
      : M(shortTitle(p.title).toUpperCase().slice(0, 10), 'multi', ['universal'], p.title.replace(/^iCarsoft\s+/i, ''), 'Multi-brand', ['allsys'], 4)
    );
    return Object.assign({}, meta, {
      handle: p.handle, name: shortTitle(p.title), title: p.title, url: p.url,
      cents: p.cents, priceStr: p.price, wasStr: p.compare || '', img: p.image || '',
      count: p.count || 0, available: p.available
    });
  });

  /* ===== 模糊搜索:每个产品预生成可检索文本(型号/标题/品牌/功能/分类) ===== */
  const normQ = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); // 去音调符,Škoda→skoda
  PRODUCTS.forEach((p) => {
    const catDef = CATS.find((c) => c.key === p.cat);
    p.hay = normQ([
      p.name, p.title, p.code, p.fn, p.vehTag, p.brand || '',
      p.brand ? (BRAND_COVERS[p.brand] || '') : '',
      catDef ? catDef.title + ' ' + catDef.eyebrow : '',
      p.veh.map((v) => VEH[v]).join(' '),
      p.tags.map((t) => FEAT[t]).join(' ')
    ].join(' '));
  });

  /* ===== 状态与筛选 ===== */
  const state = { cats: new Set(), brands: new Set(), vehs: new Set(), feats: new Set(), price: new Set(), sort: 'featured', q: '' };
  // 按当前系列预选初始筛选(用户可自由取消/切换,数据始终为全店目录)
  const COLL_PRESET = {
    'motorcycle': { cats: ['moto'] },
    'heavy-duty': { cats: ['hd'] },
    'tpms-tools': { cats: ['tpms'] },
    'marine-diagnostic-tool': { cats: ['marine'] },
    'professional-tools': { cats: ['flagship'] },
    'multi-brand': { cats: ['multi'] },
    'for-single-brand': { cats: ['single'] },
    'accessories': { cats: ['acc'] },
    'porsche': { brands: ['Porsche'] },
    'mb-sprinter-smart-obd2-tools': { brands: ['Mercedes-Benz'] },
    'bmw-mini': { brands: ['BMW / Mini'] },
    'landrover-jaguar': { brands: ['Land Rover / Jaguar'] },
    'vaws': { brands: ['VW / Audi / Škoda'] },
    'volvo-saab': { brands: ['Volvo / Saab'] },
    'opel-vauxhall': { brands: ['Opel / Vauxhall'] },
    'ford-holden': { brands: ['Ford / GM / American'] },
    'gm': { brands: ['Ford / GM / American'] },
    'peugeot-citroen': { brands: ['French / Italian'] },
    'tyt-lexus-scion-isuzu': { brands: ['Japanese / Korean'] }
  };
  const collHandle = (root.dataset.icatCollection || '').toLowerCase();
  const preset = COLL_PRESET[collHandle];
  if (preset) {
    (preset.cats || []).forEach((c) => state.cats.add(c));
    (preset.brands || []).forEach((b) => state.brands.add(b));
  }
  const PRICE_BANDS = [
    { k: 'p1', label: 'Under $200', t: (p) => p.cents < 20000 },
    { k: 'p2', label: '$200–$500', t: (p) => p.cents >= 20000 && p.cents < 50000 },
    { k: 'p3', label: '$500–$1000', t: (p) => p.cents >= 50000 && p.cents < 100000 },
    { k: 'p4', label: '$1000+', t: (p) => p.cents >= 100000 }
  ];
  const stars = () => '★★★★★';
  const $ = (sel) => root.querySelector(sel);

  // 搜索匹配:按空格分词,每个词都需命中产品检索文本(模糊子串匹配)
  function matchQuery(p) {
    if (!state.q) return true;
    const terms = normQ(state.q).split(/\s+/).filter(Boolean);
    return terms.every((t) => p.hay.indexOf(t) !== -1);
  }
  function matchExcept(p, exclude) {
    if (!matchQuery(p)) return false;
    if (exclude !== 'cats' && state.cats.size && !state.cats.has(p.cat)) return false;
    // 品牌筛选:该品牌专用工具,以及覆盖全部品牌的多车型/旗舰设备
    if (exclude !== 'brands' && state.brands.size && !(state.brands.has(p.brand) || p.cat === 'multi' || p.cat === 'flagship')) return false;
    if (exclude !== 'vehs' && state.vehs.size && !p.veh.some((v) => state.vehs.has(v))) return false;
    if (exclude !== 'feats' && state.feats.size && ![...state.feats].every((f) => p.tags.includes(f))) return false;
    if (exclude !== 'price' && state.price.size && ![...state.price].some((k) => PRICE_BANDS.find((b) => b.k === k).t(p))) return false;
    return true;
  }
  function facetCount(dim, val) {
    return PRODUCTS.filter((p) => {
      if (!matchExcept(p, dim)) return false;
      if (dim === 'cats') return p.cat === val;
      if (dim === 'brands') return p.brand === val || p.cat === 'multi' || p.cat === 'flagship';
      if (dim === 'vehs') return p.veh.includes(val);
      if (dim === 'feats') return p.tags.includes(val);
      if (dim === 'price') return PRICE_BANDS.find((b) => b.k === val).t(p);
    }).length;
  }
  function filtered() {
    let list = PRODUCTS.filter((p) => matchExcept(p, null));
    if (state.sort === 'price-asc') list.sort((a, b) => a.cents - b.cents);
    else if (state.sort === 'price-desc') list.sort((a, b) => b.cents - a.cents);
    else if (state.sort === 'rating') list.sort((a, b) => b.count - a.count || b.feat - a.feat);
    else list.sort((a, b) => b.feat - a.feat || b.count - a.count);
    return list;
  }

  /* ===== 渲染 ===== */
  function renderScenarios() {
    const el = $('#scenarios');
    el.innerHTML = SCN.map((s) => {
      const on = s.cat.length === state.cats.size && s.cat.every((c) => state.cats.has(c));
      return `<button class="scn ${on ? 'on' : ''}" data-scn="${s.id}">
        <span class="scn-ico"><svg viewBox="0 0 24 24">${s.ico}</svg></span>
        <span class="scn-t">${s.t}</span><span class="scn-c">${s.c}</span></button>`;
    }).join('');
    el.querySelectorAll('.scn').forEach((b) => b.onclick = () => {
      const s = SCN.find((x) => x.id === b.dataset.scn);
      const on = s.cat.length === state.cats.size && s.cat.every((c) => state.cats.has(c));
      state.cats = new Set(on ? [] : s.cat);
      render();
      const shell = root.querySelector('.shell');
      if (!on && shell.scrollIntoView) shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  function facetGroup(title, dim, items) {
    const active = state[dim];
    const rows = items.map((it) => {
      const c = facetCount(dim, it.val);
      const checked = active.has(it.val);
      const dis = c === 0 && !checked;
      return `<label class="opt ${checked ? 'act' : ''}" style="${dis ? 'opacity:.38;pointer-events:none' : ''}">
        <input type="checkbox" data-dim="${dim}" value="${it.val}" ${checked ? 'checked' : ''}>
        <span class="box"></span>${it.label}<span class="cnt">${c}</span></label>`;
    }).join('');
    return `<div class="fgroup"><h4>${title} <span class="n">${active.size ? active.size + ' on' : ''}</span></h4>${rows}</div>`;
  }
  function railHTML() {
    const catItems = [
      { val: 'flagship', label: 'Flagship tablets' }, { val: 'multi', label: 'Multi-brand' }, { val: 'single', label: 'Single-brand' },
      { val: 'moto', label: 'Motorcycle' }, { val: 'hd', label: 'Heavy duty' }, { val: 'marine', label: 'Marine' }, { val: 'tpms', label: 'TPMS' }, { val: 'acc', label: 'Accessories' }
    ];
    const vehItems = Object.entries(VEH).map(([k, v]) => ({ val: k, label: v }));
    const featItems = Object.entries(FEAT).map(([k, v]) => ({ val: k, label: v }));
    const priceItems = PRICE_BANDS.map((b) => ({ val: b.k, label: b.label }));
    const brandItems = BRAND_ORDER.map((bn) => ({ val: bn, label: bn }));
    const any = state.cats.size || state.brands.size || state.vehs.size || state.feats.size || state.price.size;
    return `<div class="rail-top"><h3>Refine</h3><button class="clear" data-clear ${any ? '' : 'hidden'}>Clear all</button></div>
      ${facetGroup('Category', 'cats', catItems)}
      ${facetGroup('Brand', 'brands', brandItems)}
      ${facetGroup('Vehicle', 'vehs', vehItems)}
      ${facetGroup('Feature', 'feats', featItems)}
      ${facetGroup('Price', 'price', priceItems)}`;
  }
  function bindFacets(scope) {
    scope.querySelectorAll('input[type=checkbox][data-dim]').forEach((cb) => cb.onchange = () => {
      const set = state[cb.dataset.dim];
      cb.checked ? set.add(cb.value) : set.delete(cb.value);
      render();
    });
    const clr = scope.querySelector('[data-clear]');
    if (clr) clr.onclick = () => { ['cats', 'brands', 'vehs', 'feats', 'price'].forEach((d) => state[d].clear()); render(); };
  }
  function chipLabel(dim, val) {
    if (dim === 'cats') { const c = CATS.find((x) => x.key === val); return c ? c.title.replace(' Diagnostic Tablets', ' Tablets').replace(' Diagnostics', '').replace(' & Trucks', '').replace(' & Add-ons', '') : val; }
    if (dim === 'brands') return val;
    if (dim === 'vehs') return VEH[val];
    if (dim === 'feats') return FEAT[val];
    if (dim === 'price') return PRICE_BANDS.find((b) => b.k === val).label;
  }
  function renderChips() {
    const el = $('#chips');
    const all = [];
    ['cats', 'brands', 'vehs', 'feats', 'price'].forEach((dim) => state[dim].forEach((v) => all.push([dim, v])));
    el.innerHTML = all.map(([d, v]) => `<span class="achip">${chipLabel(d, v)}<button data-d="${d}" data-v="${v}">✕</button></span>`).join('');
    el.querySelectorAll('button').forEach((b) => b.onclick = () => { state[b.dataset.d].delete(b.dataset.v); render(); });
  }
  function card(p) {
    const flag = (p.flag && p.flag !== 'new') ? `<span class="flag ${p.flag}">${p.flag === 'top' ? 'Top rated' : 'Deal'}</span>` : '';
    const tags = [`<span class="tag veh">${p.vehTag}</span>`].concat(
      p.tags.filter((t) => ['bidi', 'canfd', 'coding', 'allsys'].includes(t)).slice(0, 2).map((t) => `<span class="tag">${FEAT[t]}</span>`)
    ).join('');
    const rate = p.count > 0
      ? `<div class="rate"><span class="stars">${stars()}</span><span class="rc">${p.count} review${p.count > 1 ? 's' : ''}</span></div>`
      : `<div class="rate"><span class="stars" style="color:#d3d6db">${stars()}</span></div>`;
    const was = p.wasStr ? `<span class="was">${p.wasStr}</span>` : '';
    return `<article class="card">
      <a class="card-media" href="${p.url}"><span class="code">${p.code}</span>${flag}
        ${p.img ? `<img src="${p.img}" alt="${p.title.replace(/"/g, '&quot;')}" loading="lazy" onerror="this.style.opacity=0">` : ''}</a>
      <div class="card-body">
        <a class="card-name" href="${p.url}">${p.name}</a>
        <div class="card-fn">${p.fn}</div>
        <div class="card-tags">${tags}</div>
        ${rate}
        <div class="card-foot">
          <div class="price"><span class="now">${p.priceStr}</span>${was}</div>
          <a class="view" href="${p.url}">View <svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
        </div>
      </div>
    </article>`;
  }
  const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  function brandNav() {
    const rows = BRAND_ORDER.map((bn) => {
      const bitems = PRODUCTS.filter((p) => p.brand === bn && matchExcept(p, 'brands'));
      const on = state.brands.has(bn);
      const cheapest = bitems.length ? bitems.reduce((a, b) => (a.cents < b.cents ? a : b)) : null;
      const rep = bitems.find((p) => /(V3\.0|V2\.0)/.test(p.name)) || bitems[bitems.length - 1];
      const dis = bitems.length === 0 && !on;
      return `<button class="bcard ${on ? 'on' : ''}" data-brand="${bn}" ${dis ? 'disabled' : ''} title="${BRAND_COVERS[bn] || ''}">
        <span class="bcard-img">${rep && rep.img ? `<img src="${rep.img}" alt="${bn}" loading="lazy" onerror="this.style.opacity=0">` : ''}</span>
        <span class="bcard-tx"><span class="bcard-name">${bn}</span><span class="bcard-meta">${bitems.length} tool${bitems.length !== 1 ? 's' : ''}${cheapest ? ` · from ${cheapest.priceStr}` : ''}</span></span>
      </button>`;
    }).join('');
    return `<div class="brandnav-wrap"><div class="brandnav-h"><span class="bn-eyebrow">// Select your brand</span>${state.brands.size ? `<button class="bn-clear" data-bnclear>Show all brands</button>` : ''}</div><div class="brandnav">${rows}</div></div>`;
  }
  function renderCatalog() {
    const list = filtered();
    const el = $('#catalog');
    if (list.length === 0) {
      const msg = state.q ? `No tools match &ldquo;${state.q.replace(/</g, '&lt;')}&rdquo;` : 'No tools match those filters';
      const sub = state.q ? 'Try a different keyword, e.g. a brand (BMW), a model (CR MAX) or a function (ECU coding).' : 'Try removing a filter or two.';
      el.innerHTML = `<div class="grid"><div class="empty"><h3>${msg}</h3><p>${sub}</p><button data-emptyreset>Reset</button></div></div>`;
      el.querySelector('[data-emptyreset]').onclick = () => {
        ['cats', 'brands', 'vehs', 'feats', 'price'].forEach((d) => state[d].clear());
        state.q = '';
        const q = $('#icatQ'); if (q) q.value = '';
        render();
      };
      return;
    }
    let html = '';
    CATS.forEach((cat) => {
      const items = list.filter((p) => p.cat === cat.key);
      if (items.length === 0) return;
      html += `<section class="section"><div class="s-head"><div>
        <div class="s-eyebrow">${cat.eyebrow}</div><div class="s-title">${cat.title}</div></div>
        <div class="s-count">${items.length} unit${items.length > 1 ? 's' : ''}</div>
        <p class="s-desc">${cat.desc}</p></div>`;
      if (cat.key === 'single') {
        html += brandNav();
        BRAND_ORDER.forEach((bn) => {
          const bitems = items.filter((p) => p.brand === bn);
          if (bitems.length === 0) return;
          const cheapest = bitems.reduce((a, b) => (a.cents < b.cents ? a : b));
          html += `<div class="brandrow" id="brand-${slug(bn)}"><span class="brand-name">${bn}</span><span class="brand-meta">${bitems.length} versions · from ${cheapest.priceStr} · ${BRAND_COVERS[bn] || ''}</span><span class="rule"></span></div>`;
          html += `<div class="grid">${bitems.map(card).join('')}</div>`;
        });
      } else {
        html += `<div class="grid">${items.map(card).join('')}</div>`;
      }
      html += `</section>`;
    });
    el.innerHTML = html;
    el.querySelectorAll('.bcard').forEach((b) => b.onclick = () => {
      const bn = b.dataset.brand;
      state.brands.has(bn) ? state.brands.delete(bn) : state.brands.add(bn);
      render();
    });
    const c = el.querySelector('[data-bnclear]');
    if (c) c.onclick = () => { state.brands.clear(); render(); };
  }
  function render() {
    $('#rail').innerHTML = railHTML();
    bindFacets($('#rail'));
    const sb = $('#sheetBody');
    sb.innerHTML = railHTML();
    bindFacets(sb);
    renderScenarios();
    renderChips();
    renderCatalog();
    const n = filtered().length;
    $('#resN').textContent = n;
    const roTotal = $('#ro-total'); // 右上状态块已移除,元素可能不存在
    if (roTotal) roTotal.textContent = PRODUCTS.length;
    $('#sheetApplyBtn').textContent = `Show ${n} result${n > 1 ? 's' : ''}`;
    const active = state.cats.size + state.brands.size + state.vehs.size + state.feats.size + state.price.size;
    const mn = $('#mfilterN');
    mn.textContent = active; mn.classList.toggle('show', active > 0);
  }

  $('#sort').onchange = (e) => { state.sort = e.target.value; renderCatalog(); };
  /* 搜索框:输入即筛(轻防抖),✕ 清空 */
  const qInput = $('#icatQ'), qClear = $('#icatQx');
  if (qInput) {
    let qTimer;
    const applyQ = () => {
      state.q = qInput.value.trim();
      if (qClear) qClear.hidden = !state.q;
      render();
    };
    qInput.addEventListener('input', () => { clearTimeout(qTimer); qTimer = setTimeout(applyQ, 150); });
    qInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { clearTimeout(qTimer); applyQ(); e.preventDefault(); } });
    if (qClear) qClear.onclick = () => { qInput.value = ''; clearTimeout(qTimer); applyQ(); qInput.focus(); };
  }
  const sheet = $('#sheet'), bg = $('#sheetBg'), apply = $('#sheetApply');
  const openSheet = () => { sheet.classList.add('open'); bg.classList.add('open'); apply.classList.add('open'); document.body.style.overflow = 'hidden'; };
  const closeSheet = () => { sheet.classList.remove('open'); bg.classList.remove('open'); apply.classList.remove('open'); document.body.style.overflow = ''; };
  $('#mfilterBtn').onclick = openSheet;
  $('#sheetX').onclick = closeSheet;
  $('#sheetApplyBtn').onclick = closeSheet;
  bg.onclick = closeSheet;

  render();
})();
